import styled from "styled-components"

import MyButton from "../../elements/Button"

const Button = styled(MyButton)`
  min-width: unset;
  border: none;
  color: #67c462;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.07px;
  line-height: 19px;
  text-align: left;
  background-color: white;
  display: flex;
  align-items: flex-end;
  padding-right: 0;

  &:hover {
    box-shadow: none;
  }
  &::before {
    display: none;
  }
`

export default Button
